<template>
  <div
    class="dropdown-menu-element pointer spacex-8"
    :class="[`dropdown-menu-element_${color}`]"
    v-on="$listeners"
  >
    <div v-if="$slots.icon || leftIcon" class="dropdown-icons-wrapper">
      <slot name="icon">
        <Icon :type="leftIcon" size="16" :color="color" />
      </slot>
    </div>
    <div class="dropdown-text-wrapper">
      <span class="text grey-900 no-wrap" :class="textClass">
        <slot />
      </span>
    </div>
    <div v-if="$slots.rightIcon" class="flex-centering dropdown-icons-wrapper">
      <slot name="rightIcon" />
    </div>
    <div v-if="nested" class="flex-centering dropdown-icons-wrapper">
      <ChevronRight />
    </div>
  </div>
</template>

<script>
  import ChevronRight from '@/assets/icons/chevron-right.svg';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'DropdownMenuElement',
    components: {
      Icon,
      ChevronRight,
    },
    props: {
      nested: {
        type: Boolean,
        default: false,
      },
      textClass: String,
      leftIcon: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: 'primary',
      },
    },
  };
</script>
